import React, { useCallback, useState } from 'react';
import { DefaultFooterComponent, Popup } from '@silverfort/sf-components';
import { Schema } from 'jsonschema';

import JsonSchemaField from './JsonSchemaField';

interface MergeJsonPopupProps {
    open: boolean;
    onClose: () => void;
    jsonSchema: Schema;
    onMerge: (jsonField: string) => void;
}

const MergeJsonPopup: React.FC<MergeJsonPopupProps> = ({ open, jsonSchema, onClose, onMerge }) => {
    const [jsonField, setJsonField] = useState('');
    const [jsonError, setJsonError] = useState<string | null>(null);

    const onChange = useCallback((value, error) => {
        setJsonField(value);
        setJsonError(error);
    }, []);

    return (
        <Popup
            open={open}
            title={'Merge JSON'}
            ContentComponent={JsonSchemaField}
            ContentComponentProps={{ jsonSchema, onChange }}
            FooterComponent={DefaultFooterComponent}
            FooterComponentProps={{ primaryButtonProps: { text: 'Merge', disabled: !jsonField || !!jsonError } }}
            onClose={onClose}
            onApprove={() => onMerge(jsonField)}
            popupClassName="!w-[468px]"
        />
    );
};

export default MergeJsonPopup;
